// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contentForm[data-v-02bdd1b4] {\n  height: calc(100% - 57px);\n  overflow: auto;\n  padding: 20px;\n  width: 100%;\n}\n.contentForm .line[data-v-02bdd1b4] {\n  display: flex;\n  justify-content: space-between;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
